import { render, staticRenderFns } from "./AvanceReticularPage.vue?vue&type=template&id=3227745b&scoped=true&"
import script from "./AvanceReticularPage.vue?vue&type=script&lang=js&"
export * from "./AvanceReticularPage.vue?vue&type=script&lang=js&"
import style0 from "./AvanceReticularPage.vue?vue&type=style&index=0&id=3227745b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3227745b",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/AvanceReticularPage.vue
// module id = 205
// module chunks = 19